/*
 *
 * DirectionsPanel constants
 *
 */

export const FLEX_BREAK_TIMER_NAME = 'flexBreakTimer';
